<template>
  <v-sheet border class="rounded-lg bg-card" width="auto">
    <div class="d-flex flex-row justify-center align-center py-2">
      <v-icon :icon="icon" class="material-icons-round mr-1"></v-icon>
      <div class="text-subtitle-1">{{ title }}</div>
    </div>
    <v-divider></v-divider>
    <div class="mt-2 ml-1 mb-2 px-2 d-flex " :class="display">

      <div class="mx-6 pa-1 d-flex  flex-column align-start">
        <div v-for="item in content" :key="item" class="my-1">{{ item }}</div>
      </div>

      <div class="mx-6 pa-1 d-flex  flex-column align-start">
        <div v-for="item in content2" :key="item" class="my-1">{{ item }}</div>
      </div>

    </div>

    <div class="d-flex flex-row justify-center align-center py-2">
      <div class="text-subtitle-1 text-center w-75"><strong>Dentre outros 200 modelos disponíveis e customizáveis!</strong></div>
    </div>
  </v-sheet>
</template>

<script>

import {defineComponent, onMounted, reactive, toRefs} from 'vue';
import {useDisplay} from "vuetify";
import { useTheme } from 'vuetify'

export default defineComponent({
  props: {
    icon: String,
    title: String,
    content: Array,
    content3: Array,
    content2: Array,
  },
  setup() {
    const theme = useTheme()
    const display = useDisplay().mobile.value
    const state = reactive({
      isMobile: {useDisplay}

    })
    onMounted(() => {
    })

    return {
      ...toRefs(state),
      display,
      theme
    }

  }
});
</script>

<style scoped lang="scss">

</style>
